{
  "common": {
    "cancel": "취소",
    "save": "저장",
    "delete": "삭제",
    "done": "완료",
    "edit": "편집",
    "search": "검색",
    "loading": "불러오는 중…",
    "yes": "예",
    "no": "아니요",
    "settings": "설정",
    "back": "뒤로",
    "close": "닫기",
    "open": "열기",
    "copy": "복사",
    "restore": "복원",
    "untitled": "제목 없음",
    "create": "만들기",
    "revoke": "해제",
    "never": "없음",
    "tryAgain": "다시 시도",
    "reload": "새로 고침",
    "update": "업데이트",
    "insert": "삽입",
    "loadingShort": "불러오는 중",
    "unknown": "알 수 없음",
    "sampleSentence": "다람쥐 헌 쳇바퀴에 타고파"
  },
  "sidebar": {
    "views": "보기",
    "tags": "태그",
    "edit": "편집",
    "done": "완료",
    "account": "계정",
    "newNote": "새 노트",
    "editTag": "태그 편집",
    "tagOptions": "태그 옵션",
    "reorder": "{{label}} 순서 바꾸기",
    "showView": "{{label}} 표시",
    "hideView": "{{label}} 숨기기",
    "editViews": "보기 편집",
    "doneEditingViews": "보기 편집 완료",
    "samplePeep": "Caliu는…",
    "sampleQuiet": "생각이 머물며 숨 쉴 수 있는 조용한 곳."
  },
  "views": {
    "all": "모든 노트",
    "today": "오늘",
    "todo": "할 일",
    "pinned": "고정된 노트",
    "untagged": "태그 없음",
    "thisWeek": "이번 주",
    "shared": "내가 공유함",
    "sharedWithMe": "나와 공유됨",
    "attachments": "첨부 파일",
    "trash": "휴지통",
    "archive": "보관함"
  },
  "noteList": {
    "empty": "아직 노트가 없어요",
    "emptySubtitle": "첫 노트를 만들어 시작해 보세요.",
    "untitled": "제목 없음",
    "selectNote": "노트 선택",
    "selectNoteHint": "목록에서 노트를 고르거나 새로 만들어 보세요.",
    "selectRestoreOrDelete": "복원하거나 완전히 삭제할 노트를 선택하세요",
    "selectSharedToView": "공유된 노트를 선택하면 볼 수 있어요",
    "searchPlaceholder": "노트 검색…",
    "selectNotes": "노트 선택",
    "openSidebar": "사이드바 열기",
    "cancelSelection": "선택 취소",
    "clearSelection": "선택 해제",
    "emptyTrash": "휴지통 비우기",
    "newNote": "새 노트",
    "noteCount_one": "{{count}}개의 노트",
    "noteCount_other": "{{count}}개의 노트",
    "sortBy": "정렬 기준",
    "preview": "미리 보기",
    "modificationDate": "수정 날짜",
    "creationDate": "만든 날짜",
    "title": "제목",
    "manual": "수동",
    "newestOnTop": "최신 항목 위로",
    "small": "작게",
    "medium": "보통",
    "large": "크게",
    "empty_pinned": "고정된 노트가 없어요",
    "empty_pinned_subtitle": "노트를 고정하면 여기에서 빠르게 찾을 수 있어요.",
    "empty_today": "오늘 편집한 노트가 없어요",
    "empty_today_subtitle": "오늘 손댄 노트가 여기에 표시돼요.",
    "empty_todo": "할 일이 없어요",
    "empty_todo_subtitle": "끝내지 않은 할 일이 있는 노트가 여기에 표시돼요.",
    "empty_untagged": "모든 노트에 태그가 있어요",
    "empty_untagged_subtitle": "태그가 없는 노트가 여기에 표시돼요.",
    "empty_thisWeek": "이번 주에는 아무것도 없어요",
    "empty_thisWeek_subtitle": "최근 7일 동안 편집한 노트가 여기에 표시돼요.",
    "empty_shared": "공유한 노트가 없어요",
    "empty_shared_subtitle": "공유한 노트가 여기에 표시돼요.",
    "empty_attachments": "첨부 파일이 없어요",
    "empty_attachments_subtitle": "이미지나 파일이 있는 노트가 여기에 표시돼요.",
    "justNow": "방금 전",
    "minutesAgo": "{{count}}분 전",
    "today": "오늘",
    "yesterday": "어제",
    "deletedOn": "{{date}}에 삭제됨",
    "newNoteShortcut": "새 노트 ({{shortcut}})",
    "noContent": "내용 없음",
    "selectUnarchiveOrDelete": "보관 해제하거나 삭제할 노트를 선택하세요",
    "view": "보기",
    "density": "밀도",
    "exportAll": "전체 내보내기"
  },
  "editor": {
    "attachmentTooLarge": "이 파일은 너무 커서 첨부할 수 없어요. 최대 100 MB까지 가능해요.",
    "placeholder": "글을 써 보세요…",
    "noMatchingCommands": "일치하는 명령이 없어요",
    "newNote": "새 노트",
    "noResults": "결과 없음",
    "foldSection": "섹션 접기",
    "unfoldSection": "섹션 펼치기",
    "dragSection": "섹션 이동",
    "presenceLabel": "함께 있는 사람: {{names}}"
  },
  "noteActions": {
    "pin": "고정",
    "unpin": "고정 해제",
    "pinToTop": "맨 위에 고정",
    "makeReadOnly": "읽기 전용으로 전환",
    "makeEditable": "편집 가능으로 전환",
    "readOnlyNote": "읽기 전용 노트",
    "shareNote": "노트 공유",
    "share": "공유",
    "publiclyShared": "공개 공유 중",
    "privateNote": "비공개 노트",
    "linkCreated": "링크를 만들었어요",
    "linkCreatedAndCopied": "링크를 만들어 복사했어요",
    "linkRevoked": "공유 링크를 해제했어요",
    "failedToCreateShareLink": "공유 링크를 만들지 못했어요",
    "failedToRevokeShareLink": "공유 링크를 해제하지 못했어요",
    "thisNoteIsPrivate": "이 노트는 비공개예요.",
    "createPublicLink": "공개 링크 만들기",
    "creatingLink": "링크 만드는 중…",
    "revokeLink": "링크 해제",
    "revokingLink": "해제하는 중…",
    "copyLink": "링크 복사",
    "copyNoteId": "노트 ID 복사",
    "noteIdCopied": "노트 ID를 복사했어요",
    "exportAs": "내보내기 형식",
    "exportMarkdown": "Markdown",
    "exportPlainText": "일반 텍스트",
    "exportHtml": "HTML",
    "exportRtf": "RTF",
    "exportEpub": "ePub",
    "exportTextpack": "TextPack",
    "exportFailed": "내보내지 못했어요",
    "viewHistory": "기록 보기",
    "duplicate": "복제",
    "duplicateFailed": "노트를 복제할 수 없습니다",
    "select": "선택",
    "delete": "삭제",
    "moveToTrash": "휴지통으로 이동",
    "archive": "보관",
    "unarchive": "보관 해제",
    "tags": "태그",
    "addTag": "태그 추가",
    "noTagsYet": "아직 태그가 없어요",
    "addTagFailed": "태그를 추가하지 못했어요",
    "removeTagFailed": "태그를 제거하지 못했어요"
  },
  "userMenu": {
    "theme": "테마",
    "typography": "타이포그래피",
    "language": "언어",
    "apiKeys": "API 키",
    "devices": "기기",
    "connectedApps": "연결된 앱",
    "help": "도움말",
    "logOut": "로그아웃",
    "defaultUserName": "Caliu 사용자",
    "editName": "이름 편집",
    "nameLabel": "이름",
    "namePlaceholder": "이름을 입력하세요",
    "upgradeToPro": "Caliu Pro로 업그레이드",
    "replayOnboarding": "온보딩 다시 보기",
    "logOutTitle": "로그아웃할까요?",
    "logOutBody": "노트는 이 기기에 남아 있고 계속 읽고 쓸 수 있습니다. 동기화하려면 다시 로그인하세요.",
    "logOutPending_one": "아직 동기화되지 않은 변경 사항이 {{count}}개 있습니다. 다시 로그인할 때까지 이 기기에 남습니다.",
    "logOutPending_other": "아직 동기화되지 않은 변경 사항이 {{count}}개 있습니다. 다시 로그인할 때까지 이 기기에 남습니다.",
    "logOutKeep": "로그아웃",
    "logOutAndRemove": "로그아웃하고 노트 삭제"
  },
  "help": {
    "title": "도움말 센터",
    "searchPlaceholder": "도움말 검색",
    "noResults": "검색과 일치하는 문서가 없어요.",
    "offline": "오프라인에서는 도움말을 볼 수 없어요. 다음에 연결되면 불러올게요."
  },
  "fonts": {
    "uiFont": "UI 글꼴",
    "body": "본문",
    "headings": "제목",
    "code": "코드",
    "sans": "산세리프",
    "serif": "세리프",
    "mono": "고정폭",
    "editor": "편집기",
    "ui": "UI",
    "reset": "기본값으로 되돌리기"
  },
  "themes": {
    "light": "라이트",
    "dark": "다크",
    "system": "시스템"
  },
  "languages": {
    "systemHint": "기기에서 감지했어요",
    "names": {
      "en": "영어",
      "es": "스페인어",
      "ca": "카탈루냐어",
      "fr": "프랑스어",
      "de": "독일어",
      "it": "이탈리아어",
      "pt": "포르투갈어",
      "nl": "네덜란드어",
      "ja": "일본어",
      "zh-CN": "중국어(간체)",
      "ko": "한국어",
      "zh-TW": "중국어(번체)",
      "ru": "러시아어"
    }
  },
  "bulkActions": {
    "pinSelected": "선택 항목 고정",
    "unpinSelected": "선택 항목 고정 해제",
    "pin": "고정",
    "addTag": "태그 추가",
    "filterTags": "태그 필터…",
    "noTagsFound": "태그를 찾을 수 없어요",
    "exportSelected": "선택 항목 내보내기",
    "restoreSelected": "선택 항목 복원",
    "deletePermanently": "완전히 삭제",
    "moveToTrash": "휴지통으로 이동",
    "archiveSelected": "선택 항목 보관",
    "unarchiveSelected": "선택 항목 보관 해제",
    "exportingTitle": "노트를 내보내는 중이에요",
    "exportingBody": "잠시 걸릴 수 있어요. 끝날 때까지 이 탭을 열어 두세요.",
    "exportingProgress": "{{total}}개 중 {{done}}개"
  },
  "commandPalette": {
    "placeholder": "노트, 태그, 명령 검색…",
    "noResults": "\"{{query}}\" 검색 결과가 없어요",
    "currentNote": "현재 노트",
    "navigation": "이동",
    "notes": "노트",
    "tags": "태그",
    "newNote": "새 노트",
    "allNotes": "모든 노트",
    "todaysNotes": "오늘의 노트",
    "todo": "할 일",
    "pinnedNotes": "고정된 노트",
    "trash": "휴지통",
    "importNotes": "노트 가져오기",
    "changeTheme": "테마 변경",
    "keyboardShortcuts": "키보드 단축키",
    "pinNote": "노트 고정",
    "unpinNote": "노트 고정 해제",
    "restoreNote": "노트 복원",
    "copyShareLink": "공유 링크 복사",
    "makePrivate": "비공개로 전환",
    "toggleFullscreen": "전체 화면 전환",
    "noteInfo": "노트 정보",
    "moveToTrash": "휴지통으로 이동",
    "archiveNote": "노트 보관",
    "unarchiveNote": "노트 보관 해제",
    "archive": "보관함"
  },
  "noteHistory": {
    "title": "노트 기록",
    "requiresConnection": "노트 기록을 보려면 연결이 필요해요.",
    "reconnect": "인터넷에 다시 연결한 뒤 시도해 보세요.",
    "noHistory": "이 노트에는 아직 기록이 없어요.",
    "windowMerged": "5분 안에 이뤄진 편집은 하나의 항목으로 합쳐져요.",
    "selectVersion": "미리 볼 버전을 선택하세요",
    "encrypted": "암호화된 스냅샷",
    "encryptedHint": "이 버전은 종단 간 암호화로 저장됐어요. 현재 내용을 보려면 노트를 여세요.",
    "restoreVersion": "이 버전으로 복원할까요?",
    "restoreVersionHint": "노트의 현재 내용을 {{date}} 버전으로 바꿔요.",
    "current": "현재",
    "created": "생성",
    "trashed": "휴지통으로 이동",
    "restored": "복원",
    "edited": "편집"
  },
  "apiKeys": {
    "title": "API 키",
    "empty": "아직 API 키가 없어요.",
    "emptyHint": "하나 만들어 API를 사용해 보세요.",
    "created": "{{date}}에 생성",
    "lastUsed": "마지막 사용: {{date}}",
    "revokeKey": "키 해제",
    "viewApiDocs": "API 문서 보기",
    "newApiKey": "새 API 키",
    "apiKeyCreated": "API 키를 만들었어요",
    "createApiKey": "API 키 만들기",
    "copyHint": "지금 이 키를 복사하세요. 다시 볼 수 없어요.",
    "copyToClipboard": "클립보드에 복사",
    "keyName": "키 이름",
    "keyNamePlaceholder": "예: 내 스크립트, Zapier 연동",
    "createKey": "키 만들기",
    "revokeKeyTitle": "API 키 해제",
    "revokeKeyHint": "이 API 키를 영구히 해제해요. 이 키를 쓰는 앱은 즉시 접근 권한을 잃어요.",
    "keyPrefix": "caliu_{{prefix}}…"
  },
  "connectedApps": {
    "title": "연결된 앱",
    "empty": "아직 연결된 앱이 없어요.",
    "emptyHint": "Claude, ChatGPT 또는 다른 AI 어시스턴트를 연결하면 채팅에서 노트를 사용할 수 있어요. 방법은 도움말의 'AI와 함께 쓰는 Caliu' 섹션에서 확인하세요.",
    "connected": "{{date}}에 연결",
    "lastUsed": "마지막 사용: {{date}}",
    "revoke": "연결 해제",
    "revokeTitle": "연결 해제",
    "revokeHint": "<strong>{{name}}</strong>의 Caliu 계정 접근 권한을 해제하고, 사용하던 인증 정보를 삭제해요. 즉시 접근 권한을 잃어요.",
    "thisApp": "이 앱",
    "defaultScope": "mcp"
  },
  "noteStats": {
    "writing": "작성",
    "metadata": "메타데이터",
    "words": "단어",
    "characters": "문자",
    "paragraphs": "문단",
    "readTime": "읽는 시간",
    "minutes": "{{count}}분",
    "tags": "태그",
    "outgoingLinks": "나가는 링크",
    "backlinks": "백링크",
    "created": "만든 날짜",
    "modified": "수정한 날짜",
    "noteStatistics": "노트 통계",
    "identifier": "식별자"
  },
  "inspector": {
    "tabInfo": "정보",
    "tabOutline": "개요",
    "tabHistory": "기록",
    "dates": "날짜",
    "noHeadings": "이 노트에는 제목이 없어요",
    "noBacklinks": "이 노트로 연결된 노트가 없어요",
    "noOutgoing": "이 노트는 아무 곳도 연결하지 않아요",
    "noAttachments": "이 노트에는 첨부 파일이 없어요",
    "historyOffline": "버전 기록을 보려면 연결이 필요해요",
    "historyLoadMore": "더 불러오기"
  },
  "devices": {
    "title": "기기",
    "offline": "오프라인 상태예요.",
    "offlineHint": "인터넷에 연결하면 기기를 볼 수 있어요.",
    "noSessions": "활성 세션이 없어요.",
    "thisDevice": "현재 기기",
    "lastUsed": "마지막 사용: {{date}}",
    "created": "생성: {{date}}",
    "signOutCurrent": "이 기기에서 로그아웃",
    "signOut": "로그아웃",
    "confirmCurrentTitle": "이 기기에서 로그아웃할까요?",
    "confirmRevokeTitle": "기기 연결을 해제할까요?",
    "confirmCurrentBody": "이 브라우저의 Caliu에서 로그아웃되고, 노트는 이 기기에서 삭제돼요. 언제든 다시 로그인하면 계정에서 다시 받아와요.",
    "confirmRevokeBody": "해당 기기가 즉시 로그아웃돼요. 그 기기에 있는 동기화되지 않은 변경 사항은 다시 로그인할 때까지 그대로 남아요.",
    "revoke": "연결 해제"
  },
  "errorScreen": {
    "title": "문제가 생겼어요",
    "defaultMessage": "예기치 못한 오류가 생겼어요. 페이지를 새로 고쳐 보세요."
  },
  "importModal": {
    "title": "노트 가져오기",
    "dropToImport": "놓아서 가져오기",
    "dropOrClick": "파일을 끌어다 놓거나 클릭해서 선택하세요",
    "removeFile": "파일 제거",
    "keepNote": "Google Keep은 Takeout ZIP으로 내보낸 뒤 그 압축 파일을 그대로 올려 주세요.",
    "importedCount_one": "노트 <strong>{{count}}</strong>개를 가져왔어요",
    "importedCount_other": "노트 <strong>{{count}}</strong>개를 가져왔어요",
    "fromSource": " ({{source}}에서)",
    "importing": "가져오는 중…",
    "importN": "파일 {{count}}개 가져오기",
    "importBtn": "가져오기"
  },
  "share": {
    "shareNote": "노트 공유",
    "publiclySharedAria": "노트가 공개로 공유되고 있어요",
    "copyLink": "링크 복사",
    "revokingLink": "해제하는 중…",
    "revokeLink": "링크 해제",
    "creatingLink": "링크 만드는 중…",
    "createPublicLink": "공개 링크 만들기",
    "shareThisNotePublicly": "이 노트를 공개로 공유",
    "thisNoteIsPrivate": "이 노트는 비공개예요.",
    "publiclyShared": "공개 공유 중",
    "privateNote": "비공개 노트"
  },
  "shortcuts": {
    "searchPlaceholder": "단축키 검색…",
    "pressNew": "새 단축키를 누르세요…",
    "resetToDefault": "기본값으로 되돌리기",
    "noMatches": "“<strong>{{query}}</strong>”에 해당하는 단축키가 없어요",
    "navigate": "이동",
    "edit": "편집",
    "closeAction": "닫기",
    "resetAll": "모두 초기화"
  },
  "tagEditor": {
    "icon": "아이콘",
    "color": "색상",
    "searchIcons": "아이콘 검색",
    "noIcons": "일치하는 아이콘이 없습니다",
    "categories": {
      "essentials": "기본",
      "work": "업무와 기술",
      "ideas": "아이디어와 창작",
      "life": "사람과 집",
      "travel": "여행과 자연",
      "fun": "음식, 건강, 여가"
    }
  },
  "tagActions": {
    "pin": "태그 고정",
    "unpin": "태그 고정 해제",
    "rename": "이름 바꾸기…",
    "renameTitle": "태그 이름 바꾸기",
    "renameConfirm": "이름 바꾸기",
    "renameHint": "태그는 보관한 노트와 휴지통을 포함해, 사용 중인 모든 노트에서 함께 바뀌어요.",
    "renamed": "태그 이름을 바꿨어요",
    "nameInUse": "이미 사용 중인 이름이에요",
    "invalidName": "태그 이름에는 문자, 숫자, 공백, 하이픈, 밑줄만 쓸 수 있어요",
    "pinFailed": "태그를 업데이트하지 못했어요",
    "renameFailed": "태그 이름을 바꾸지 못했어요",
    "editAppearance": "모양 편집"
  },
  "auth": {
    "appName": "Caliu",
    "or": "또는",
    "email": "이메일",
    "emailPlaceholder": "you@example.com",
    "password": "비밀번호",
    "passwordPlaceholder": "비밀번호",
    "name": "이름",
    "namePlaceholder": "이름을 입력하세요",
    "confirmPassword": "비밀번호 확인",
    "newPassword": "새 비밀번호",
    "confirmNewPassword": "새 비밀번호 확인",
    "signInSubtitle": "계정에 로그인하세요",
    "createAccountSubtitle": "계정을 만드세요",
    "forgotPassword": "비밀번호를 잊으셨나요?",
    "signingIn": "로그인 중…",
    "signIn": "로그인",
    "noAccount": "계정이 없으신가요?",
    "signUp": "가입하기",
    "haveAccount": "이미 계정이 있으신가요?",
    "creatingAccount": "계정 만드는 중…",
    "createAccount": "계정 만들기",
    "googleSignUpAria": "Google로 가입",
    "signupClosedTitle": "지금은 가입을 받지 않아요",
    "signupClosedBody": "Caliu는 비공개 베타 중이에요. caliuapp.com에서 대기자 명단에 등록하면 먼저 사용해 볼 수 있어요.",
    "joinWaitlist": "대기자 명단에 등록",
    "forgotTitle": "비밀번호 재설정",
    "forgotSubtitle": "이메일을 입력하면 재설정 링크를 보내 드려요.",
    "sendResetLink": "재설정 링크 보내기",
    "sending": "보내는 중…",
    "checkYourEmail": "메일함을 확인하세요",
    "resetLinkSentPrefix": "만약 ",
    "resetLinkSentSuffix": " 계정이 있다면 비밀번호 재설정 링크를 보내 드렸어요. 링크는 1시간 뒤에 만료돼요.",
    "backToSignIn": "로그인으로 돌아가기",
    "verifySentPrefix": "확인 링크를 ",
    "verifySentSuffix": " 주소로 보냈어요. 링크를 눌러 계정을 활성화하세요.",
    "linkExpires10m": "링크는 10분 뒤에 만료돼요.",
    "resending": "다시 보내는 중…",
    "resendEmail": "메일 다시 보내기",
    "wrongEmail": "이메일이 잘못됐나요?",
    "goBack": "돌아가기",
    "invalidResetLinkTitle": "유효하지 않은 재설정 링크",
    "invalidResetLinkBody": "이 링크는 유효하지 않거나 만료됐어요.",
    "requestNewLink": "새 링크 요청하기",
    "setNewPasswordTitle": "새 비밀번호 설정",
    "setNewPasswordHint": "안전한 비밀번호를 정하세요.",
    "updatingPassword": "업데이트 중…",
    "updatePassword": "비밀번호 업데이트",
    "localNotesTitle": "이 기기에 노트가 있습니다",
    "localNotesBody_one": "로그인 전에 여기서 {{count}}개의 노트를 작성했습니다. 어떻게 할까요?",
    "localNotesBody_other": "로그인 전에 여기서 {{count}}개의 노트를 작성했습니다. 어떻게 할까요?",
    "localNotesDelete": "삭제하기",
    "localNotesMerge": "내 계정에 추가하기",
    "backToMyNotes": "내 노트로 돌아가기",
    "errorGoogleAuthFailed": "Google 로그인에 실패했습니다. 다시 시도해 주세요.",
    "errorInvalidToken": "유효하지 않은 인증 링크입니다. 다시 가입해 주세요.",
    "errorEmailTaken": "이미 사용 중인 이메일입니다. 로그인해 주세요.",
    "signInInstead": "해당 계정으로 로그인하기",
    "errorIdentityTaken": "이 로그인 방법은 이미 다른 Caliu 계정에 연결되어 있습니다. 해당 계정으로 로그인하세요.",
    "parkedNotesTitle": "다른 계정의 노트",
    "parkedNotesBody_one": "{{email}}(으)로 로그인하면 그 계정의 노트를 이 기기에 남길 수 있어요. 다른 계정으로 로그인하면 이후에 쓴 것까지 포함해 여기 있는 노트 한 개가 지워져요.",
    "parkedNotesBody_other": "{{email}}(으)로 로그인하면 그 계정의 노트를 이 기기에 남길 수 있어요. 다른 계정으로 로그인하면 이후에 쓴 것까지 포함해 여기 있는 노트 {{count}}개가 모두 지워져요.",
    "parkedNotesBodyNoEmail_one": "로그아웃한 계정으로 로그인하면 그 계정의 노트를 이 기기에 남길 수 있어요. 다른 계정으로 로그인하면 이후에 쓴 것까지 포함해 여기 있는 노트 한 개가 지워져요.",
    "parkedNotesBodyNoEmail_other": "로그아웃한 계정으로 로그인하면 그 계정의 노트를 이 기기에 남길 수 있어요. 다른 계정으로 로그인하면 이후에 쓴 것까지 포함해 여기 있는 노트 {{count}}개가 모두 지워져요.",
    "parkedNotesContinue": "계속"
  },
  "connectors": {
    "wantsAccess": "앱이 Caliu 접근을 요청해요",
    "couldntLoad": "이 요청을 불러오지 못했어요",
    "authorize": "승인",
    "keepHappeningHint": "이런 일이 계속되면 MCP 클라이언트에서 커넥터를 삭제한 뒤 다시 추가해 보세요.",
    "backToCaliu": "Caliu로 돌아가기",
    "askingPermissionPrefix": "앱이 Caliu의 MCP 서버를 통해 내 노트와 태그를 읽고 수정할 권한을 요청해요.",
    "signedInAs": "{{name}}(으)로 로그인했어요.",
    "permissions": "권한",
    "deny": "거부",
    "allow": "허용"
  },
  "editorTypography": {
    "fontSize": "글자 크기",
    "lineHeight": "줄 간격",
    "paragraphSpacing": "문단 간격"
  },
  "emptyState": {
    "cmdGlyph": "⌘",
    "ctrlGlyph": "Ctrl",
    "shiftGlyph": "Shift"
  },
  "floatingMenu": {
    "undo": "실행 취소",
    "redo": "다시 실행",
    "taskList": "체크리스트",
    "bulletList": "글머리 기호 목록",
    "orderedList": "번호 매기기 목록",
    "blockQuote": "인용구",
    "separator": "구분선",
    "insertTag": "태그 삽입",
    "highlight": "형광펜",
    "math": "수식",
    "removeHighlight": "형광펜 지우기",
    "inlineCode": "인라인 코드",
    "codeBlock": "코드 블록",
    "insertTable": "표 삽입",
    "insertImage": "이미지 삽입",
    "hideStyleBar": "스타일 바 숨기기",
    "attachFile": "파일 첨부",
    "photoLibrary": "사진 보관함",
    "camera": "카메라",
    "fromFile": "파일에서"
  },
  "imageDialog": {
    "title": "이미지 삽입",
    "tabUpload": "파일",
    "tabUrl": "URL",
    "urlLabel": "이미지 URL",
    "urlPlaceholder": "https://example.com/image.jpg",
    "altLabel": "대체 텍스트",
    "altPlaceholder": "이미지를 설명해 주세요…",
    "previewAlt": "미리 보기",
    "changeImage": "이미지 변경",
    "dropToInsert": "놓아서 삽입",
    "dropOrClick": "이미지를 끌어다 놓거나 클릭해서 선택하세요",
    "formats": "PNG, JPG, GIF, WebP",
    "insert": "이미지 삽입"
  },
  "linkDialog": {
    "editTitle": "링크 편집",
    "insertTitle": "링크 삽입",
    "textLabel": "텍스트",
    "textPlaceholder": "링크 텍스트",
    "urlPlaceholder": "https://example.com",
    "removeLink": "링크 제거",
    "openLink": "링크 열기",
    "editLink": "링크 편집"
  },
  "noteEditor": {
    "notFound": "노트를 찾을 수 없어요.",
    "inTrashBanner": "이 노트는 휴지통에 있어요. 편집하려면 복원하세요.",
    "restore": "복원",
    "noContent": "이 노트에는 내용이 없어요."
  },
  "noteHeader": {
    "noteInfo": "노트 정보"
  },
  "table": {
    "deleteRow": "행 삭제",
    "deleteTable": "표 삭제",
    "addRow": "행 추가",
    "addRowAbove": "위에 행 추가",
    "addColumn": "열 추가",
    "addColumnBefore": "앞에 열 추가",
    "moveRowUp": "행 위로 이동",
    "moveRowDown": "행 아래로 이동",
    "moveColumnLeft": "열 왼쪽으로 이동",
    "moveColumnRight": "열 오른쪽으로 이동",
    "deleteColumn": "열 삭제",
    "actions": "표 동작"
  },
  "syncIndicator": {
    "synced": "동기화됨",
    "pending_one": "동기화 대기 {{count}}개",
    "pending_other": "동기화 대기 {{count}}개",
    "offline": "오프라인",
    "offlinePending_one": "오프라인 · {{count}}개 대기 중",
    "offlinePending_other": "오프라인 · {{count}}개 대기 중",
    "syncing": "동기화 중...",
    "conflict_one": "충돌 {{count}}개",
    "conflict_other": "충돌 {{count}}개",
    "error": "동기화 오류",
    "syncedTooltip": "모든 변경 사항을 저장했어요",
    "pendingTooltip_one": "변경 사항 {{count}}개가 동기화를 기다리고 있어요",
    "pendingTooltip_other": "변경 사항 {{count}}개가 동기화를 기다리고 있어요",
    "offlineTooltip": "오프라인: 다시 연결되면 변경 사항이 동기화돼요",
    "offlinePendingTooltip_one": "오프라인: 다시 연결되면 변경 사항 {{count}}개가 동기화돼요",
    "offlinePendingTooltip_other": "오프라인: 다시 연결되면 변경 사항 {{count}}개가 동기화돼요",
    "syncingTooltip": "동기화 중...",
    "syncingPendingTooltip_one": "변경 사항 {{count}}개를 동기화하는 중...",
    "syncingPendingTooltip_other": "변경 사항 {{count}}개를 동기화하는 중...",
    "conflictTooltip_one": "노트 {{count}}개에 충돌하는 변경 사항이 있어요. 눌러서 해결하세요.",
    "conflictTooltip_other": "노트 {{count}}개에 충돌하는 변경 사항이 있어요. 눌러서 해결하세요.",
    "errorTooltip": "동기화에 실패했어요. 자동으로 다시 시도할게요.",
    "conflictsTitle": "충돌 해결",
    "local": "이 기기에서",
    "localTooltip": "이 기기에만 저장돼요. 동기화하려면 로그인하세요."
  },
  "image": {
    "download": "이미지 다운로드",
    "replace": "이미지 교체",
    "remove": "이미지 삭제"
  },
  "sharePage": {
    "goToCaliu": "Caliu로 가기",
    "noteNotFoundTitle": "노트를 찾을 수 없어요",
    "somethingWentWrong": "문제가 생겼어요",
    "lastUpdated": "마지막 업데이트: {{date}}",
    "tagline": "생각하는 사람을 위한 노트 앱",
    "subtagline": "Markdown으로 쓰고, 어디서나 동기화하고, 맑게 생각하세요.",
    "startWriting": "글쓰기 시작",
    "signIn": "로그인",
    "openInCaliu": "Caliu에서 열기",
    "adding": "추가하는 중…",
    "addToSharedList": "내 공유 목록에 추가",
    "notFoundSubtitle": "이 공유 링크는 만료됐거나 해제됐을 수 있어요.",
    "errorSubtitle": "이 노트를 불러올 수 없어요. 다시 시도해 주세요."
  },
  "sharedView": {
    "loading": "공유 노트를 불러오는 중…",
    "sharedWithYou": "나와 공유됨",
    "viewRaw": "원본 Markdown 보기",
    "viewRendered": "정리된 노트 보기",
    "copyMarkdown": "Markdown 복사",
    "markdownCopied": "Markdown을 복사했어요",
    "copyFailed": "복사하지 못했어요",
    "notLoadedYet": "이 노트는 아직 다 불러오지 못했어요",
    "linkCopied": "링크를 복사했어요",
    "actions": "노트 동작"
  },
  "sharedWithMe": {
    "title": "나와 공유됨",
    "removeFromList": "목록에서 제거",
    "empty": "아직 공유된 노트가 없어요",
    "emptyHint": "친구가 보낸 Caliu 공유 링크를 열면 여기에 추가돼요. 공유된 노트는 모든 기기에서 동기화돼요."
  },
  "trashView": {
    "empty": "휴지통이 비어 있어요",
    "emptyHint": "삭제한 노트가 여기에 표시돼요",
    "retention": "휴지통의 노트는 30일 뒤에 완전히 삭제돼요",
    "trash": "휴지통"
  },
  "fileAttachment": {
    "download": "파일 다운로드",
    "remove": "파일 삭제"
  },
  "archiveView": {
    "archive": "보관함",
    "empty": "보관함이 비어 있어요",
    "emptyHint": "보관한 노트가 여기에 표시돼요",
    "archivedOn": "{{date}}에 보관"
  },
  "pro": {
    "subtitle": "Caliu의 모든 것을, 남김없이.",
    "features": [
      "무제한 노트",
      "노트 버전 기록",
      "PDF, HTML, RTF, ePub 내보내기 + 일괄 내보내기",
      "모든 테마와 글꼴, 앱 아이콘",
      "Caliu의 개발을 응원해요"
    ],
    "perMonth": "월 {{price}}",
    "perWeek": "주 {{price}}",
    "oneTime": "{{price}} 일회 결제",
    "perYear": "연 {{price}}",
    "or": "또는",
    "signInToSubscribe": "로그인하고 구독하기",
    "accountRequired": "Caliu Pro는 계정에 연결되어 모든 기기에서 사용할 수 있어요.",
    "plansUnavailable": "요금제를 불러오지 못했어요. 연결을 확인한 뒤 다시 시도해 주세요.",
    "yearly": "연간",
    "monthly": "월간",
    "continue": "계속",
    "bestValue": "가장 알뜰해요",
    "autoRenew": "{{amount}}. 해지할 때까지 자동으로 갱신돼요. 언제든 해지할 수 있어요.",
    "freeTrial": "{{count}}일 무료",
    "billedSubtitle": "{{count}}일 무료, 이후에는 {{amount}} 요금이 자동으로 결제돼요. 언제든 해지할 수 있어요.",
    "startTrial": "무료 체험 시작",
    "upgradeSubtitle": "버전 기록, 모든 테마와 글꼴, 내보내기 등.",
    "upgradeNow": "지금 업그레이드",
    "thanks": "Caliu를 응원해 주셔서 고마워요!",
    "renewsOn": "{{date}}에 갱신",
    "endsOn": "{{date}}에 종료",
    "lifetime": "평생 이용",
    "lifetimePlan": "평생",
    "oneTimeNoRenewal": "일회성 결제",
    "launchPrice": "출시 기념 가격입니다. 이후 {{price}}(으)로 인상됩니다.",
    "buy": "구매",
    "oneTimeDisclosure": "{{amount}}. 일회성 결제, 갱신 없음.",
    "thanksMessage": "응원 덕분에 Caliu가 독립적이고 사적인 앱으로 남을 수 있어요.",
    "manageSubscription": "구독 관리",
    "contactUs": "궁금한 점이 있나요? 문의하기",
    "grandfatheredNote": "초기 후원자에게 Caliu Pro는 평생 무료예요. 갱신할 것도 없어요.",
    "webFootnote": "PDF 내보내기는 아직 웹에서 쓸 수 없어요.",
    "active": "사용 중"
  },
  "find": {
    "placeholder": "노트에서 찾기",
    "matchCount": "{{current}}/{{total}}",
    "noResults": "결과 없음",
    "next": "다음 결과",
    "previous": "이전 결과",
    "close": "닫기"
  },
  "conflicts": {
    "description": "이 노트는 다른 기기에서도 편집됐어요. 한 가지 버전을 선택하세요.",
    "yours": "내 버전",
    "theirs": "다른 버전",
    "step": "{{total}}개 중 {{current}}번째",
    "keepYours": "내 버전 유지",
    "keepTheirs": "다른 버전 유지",
    "serverError": "다른 버전을 불러오지 못했어요.",
    "done": "모든 충돌을 해결했어요.",
    "previous": "이전 충돌",
    "next": "다음 충돌",
    "copyOf": "{{title}} 사본"
  },
  "onboarding": {
    "welcomeTitle": "Caliu에 오신 것을 환영해요",
    "welcomeSubtitle": "생각이 머물며 숨 쉴 수 있는 조용한 곳.",
    "getStarted": "시작하기",
    "magicTitle": "적은 그대로 모양을 갖춰요",
    "magicSubtitle": "그냥 텍스트로 쓰면 돼요. Caliu가 할 일과 형광펜, 스스로 정리되는 태그로 바꿔 줘요.",
    "magicLearnMore": "Markdown 기초 배우기",
    "replay": "다시 보기",
    "demoTitle": "바닷가의 여름",
    "demoBody": "작은 마을에서 보내는 **느긋한 일주일**.",
    "demoTask": "작은 집 예약하기",
    "demoHighlight": "아침 식사 ==전==에 수영하기",
    "demoTags": "#여름 #계획",
    "intentTitle": "여기에 무엇을 담아 볼까요?",
    "intentSubtitle": "몇 가지 골라 보세요. 첫 노트와 태그가 이미 준비돼 기다리고 있어요.",
    "themeTitle": "나만의 빛을 고르세요",
    "themeSubtitle": "글 쓰는 기분에 맞출 수 있는 다양한 테마.",
    "proTitle": "처음부터 전부 누리세요",
    "proSubtitle": "첫날부터 모든 기능을 써 보세요. 무료로 시작하고, 값어치를 한다고 느낄 때만 이어 가세요.",
    "proTrust": "광고 없어요. 속임수 없어요. 언제든 해지할 수 있어요.",
    "tryProFree": "Pro 무료로 체험하기",
    "continueFree": "무료 플랜으로 계속하기",
    "allSetTitle": "모든 준비가 끝났어요",
    "allSetSubtitle": "Caliu에 오신 것을 환영해요. 마음껏 나만의 것으로 만들어 보세요.",
    "startWriting": "글쓰기 시작",
    "firstNoteTitle": "여기에서 시작해요",
    "firstNoteBody": "제 첫 노트예요. 이 기기에 저장되고, 오프라인에서도 열리고, 어디를 가든 저를 따라와요.",
    "firstNoteTask": "간직할 만한 생각 하나 적어 두기",
    "next": "다음",
    "skip": "건너뛰기",
    "back": "뒤로",
    "intents": {
      "journal": "일기",
      "ideas": "아이디어",
      "work": "일",
      "study": "공부",
      "reading": "독서",
      "plans": "계획"
    },
    "signInCta": "로그인 또는 회원가입",
    "continueWithoutAccount": "계정 없이 계속하기",
    "backupTitle": "노트가 저장되는 곳",
    "backupSubtitle": "노트는 이 기기에서 시작해요. 계정이 있으면 동기화되어 안전한 사본이 모든 기기에 전해져요.",
    "syncOffTitle": "동기화가 꺼져 있어요",
    "syncOffBody": "로그인하면 모든 기기에서 노트를 동기화할 수 있어요.",
    "backupSignedIn": "작성하는 동안 노트가 안전하게 동기화돼요.",
    "backupStageDevice": "이 기기",
    "backupStageSafe": "동기화됨",
    "backupStageEverywhere": "모든 기기",
    "freeNotes": "계정 없이 무료 노트 {{limit}}개를 영원히. Pro는 무제한이에요."
  },
  "backup": {
    "evictionNotice": "지금 노트는 이 브라우저에만 저장돼요. 저장 공간이 부족하면 브라우저가 사이트 데이터를 지울 수 있어요.",
    "dismiss": "닫기",
    "signIn": "로그인"
  },
  "gate": {
    "share": "로그인하면 노트를 공유할 수 있습니다.",
    "history": "로그인하면 버전 기록을 보관할 수 있습니다.",
    "import": "로그인하면 노트를 가져올 수 있습니다."
  },
  "math": {
    "placeholder": "LaTeX",
    "sourceLabel": "LaTeX 소스"
  },
  "noteLimit": {
    "banner": "{{limit}}개 중 {{count}}개 노트",
    "paywallTitle": "무료 노트 {{limit}}개에 도달했어요",
    "paywallBody": "편집, 검색, 동기화는 계속 쓸 수 있어요. 노트를 휴지통으로 옮기면 자리가 생겨요. Caliu Pro면 무제한이에요. 월간, 연간, 또는 평생 이용권 1회 구매 중에서 고르세요.",
    "importCapped": "{{total}}개 파일 중 {{count}}개만 가져왔어요. 무료 플랜에서는 노트를 {{limit}}개까지 만들 수 있어요."
  },
  "appUpdate": {
    "available": "Caliu의 새 버전을 사용할 수 있습니다."
  },
  "settings": {
    "title": "설정",
    "account": "계정",
    "writing": "글쓰기",
    "keyboardShortcuts": "키보드 단축키",
    "editor": "에디터",
    "yourNotes": "내 노트",
    "about": "정보",
    "noAccount": "계정 없음",
    "sendFeedback": "의견 보내기",
    "signInOrCreate": "로그인 또는 회원가입",
    "notesComeWithYou": "이 기기의 노트는 그대로 함께 옮겨집니다.",
    "notSyncing": "동기화 안 됨",
    "signInToSync": "로그인하면 노트를 동기화할 수 있어요.",
    "sync": "동기화",
    "security": "보안",
    "communications": "소식",
    "newsletter": "Caliu 뉴스레터",
    "newsletterFooter": "새 버전과 Caliu에 곧 추가될 기능을 가끔 짧은 메일로 알려 드려요.",
    "newsletterError": "뉴스레터 설정을 업데이트하지 못했어요. 다시 시도해 주세요.",
    "appearance": "모양",
    "themes": "테마",
    "sizing": "크기",
    "systemDefault": "시스템 기본값",
    "separateThemes": "라이트와 다크에 다른 테마 사용",
    "maxWidth": "최대 너비",
    "maxWidthHint": "넓은 화면에서 읽기 좋은 너비로 글을 가운데 정렬해요",
    "markdownReturn": "Markdown 스타일 Return",
    "markdownReturnHint": "Return 키는 줄을 바꿉니다. 새 단락을 시작하려면 Return을 두 번 누르세요",
    "newNoteStart": "새 메모 시작",
    "newNoteStartH1": "제목 1",
    "newNoteStartH2": "제목 2",
    "newNoteStartH3": "제목 3",
    "newNoteStartH4": "제목 4",
    "newNoteStartDate": "날짜",
    "newNoteStartDateIso": "날짜(ISO 8601)",
    "newNoteStartDateTime": "날짜 및 시간",
    "newNoteStartDateTimeIso": "날짜 및 시간(ISO 8601)",
    "newNoteStartEmpty": "비어 있음",
    "newNoteStartHint": "앱에서 만드는 메모에 적용됩니다.",
    "collapsibleSections": "접을 수 있는 섹션",
    "collapsibleSectionsHint": "제목과 그 내용을 화살표로 접을 수 있게 해요",
    "experimental": "실험적 기능",
    "general": "일반"
  },
  "toolbar": {
    "toggleSidebar": "사이드바 보기/숨기기",
    "toggleInspector": "인스펙터 보기/숨기기",
    "searchNotes": "노트 검색",
    "newNote": "새 노트",
    "findInNote": "노트에서 찾기",
    "showToolbar": "툴바 보기",
    "hideToolbar": "툴바 숨기기",
    "moreNoteActions": "노트 추가 작업",
    "undo": "실행 취소",
    "redo": "다시 실행",
    "zenMode": "Zen 모드",
    "sourceMode": "소스 모드",
    "richEditor": "리치 에디터",
    "sortBy": "정렬 기준",
    "bold": "굵게",
    "italic": "기울임",
    "heading": "제목",
    "list": "목록",
    "link": "링크",
    "insert": "삽입",
    "more": "더 보기",
    "strikethrough": "취소선",
    "table": "표",
    "horizontalRule": "가로줄",
    "codeBlock": "코드 블록",
    "inlineCode": "인라인 코드",
    "blockQuote": "인용구",
    "math": "수식",
    "highlight": "형광펜",
    "bulletList": "글머리 기호 목록",
    "orderedList": "번호 매기기 목록",
    "photoLibrary": "사진 보관함",
    "camera": "카메라",
    "files": "파일",
    "yellow": "노랑",
    "green": "초록",
    "blue": "파랑",
    "pink": "분홍",
    "purple": "보라",
    "heading1": "제목 1",
    "heading2": "제목 2",
    "heading3": "제목 3",
    "heading4": "제목 4",
    "heading5": "제목 5",
    "heading6": "제목 6",
    "removeHighlight": "형광펜 지우기"
  },
  "whatsNew": {
    "title": "새로운 기능",
    "tagIconsTitle": "Caliu를 위해 그린 아이콘",
    "tagIconsBody": "앱의 모든 아이콘이 새로워졌어요. 모두 Caliu를 위해 만들었어요. 태그마다 아이콘을 지정하고 한국어로 검색해 보세요.",
    "newNoteStartTitle": "원하는 방식으로 노트 시작하기",
    "newNoteStartBody": "새 노트를 제목, 오늘 날짜, 날짜와 시간, 또는 빈 페이지로 시작할 수 있어요. 설정의 에디터에서 고르세요.",
    "typographyTitle": "글자를 정확한 값으로",
    "typographyBody": "설정의 타이포그래피에서 노트의 글자 크기, 줄 간격, 문단 간격을 정확한 값으로 고르세요.",
    "typographySample": "모든 노트가 설정한 크기, 줄 간격, 간격을 포인트 단위까지 그대로 따라요.",
    "sampleMorningPages": "모닝 페이지",
    "newsletterTitle": "Caliu 뉴스레터를 시작해요",
    "newsletterBody": "이제 릴리스마다 새로운 기능을 짧은 이메일로, 사용하시는 언어로 알려 드려요. 원하시면 켜 주세요. 설정에서 언제든지 바꿀 수 있어요."
  },
  "sharing": {
    "inviteByEmail": "이메일로 초대",
    "invite": "초대",
    "roleOwner": "소유자",
    "roleEditor": "편집 가능",
    "roleViewer": "보기 가능",
    "generalAccess": "일반 액세스",
    "shareWithLink": "링크로 공유",
    "accessRestricted": "초대한 사람만",
    "accessView": "링크가 있는 모든 사용자가 보기 가능",
    "accessEdit": "링크가 있는 모든 사용자가 편집 가능",
    "remove": "제거",
    "leave": "나가기",
    "leaveNote": "노트에서 나가기",
    "leaveConfirmTitle": "이 노트에서 나갈까요?",
    "leaveConfirmBody": "모든 기기의 목록에서 사라져요. 소유자가 다시 초대할 수 있어요.",
    "leaveSelectedTitle": "공유 노트에서 나갈까요?",
    "leaveSelectedBody_one": "나와 공유된 노트 {{count}}개에서 나가요. 내 노트는 휴지통으로 이동해요.",
    "leaveSelectedBody_other": "나와 공유된 노트 {{count}}개에서 나가요. 내 노트는 휴지통으로 이동해요.",
    "sharedBy": "{{name}} 님이 공유함",
    "sharedList": "공유됨",
    "viewOnly": "보기 전용",
    "accessNowEditor": "이제 이 노트를 편집할 수 있어요.",
    "accessNowViewer": "이제 이 노트를 보기만 할 수 있어요.",
    "accessRemoved": "이 노트에 더 이상 접근할 수 없어요.",
    "unsentSavedAsCopy": "전송되지 않은 변경 사항은 사본으로 저장했어요.",
    "privateNote": "비공개 노트",
    "memberLimit": "노트는 최대 50명과 공유할 수 있어요.",
    "rateLimit": "초대가 너무 많아요. 나중에 다시 시도하세요.",
    "inviteFailed": "초대를 보내지 못했어요. 다시 시도하세요.",
    "invalidEmail": "올바른 이메일 주소를 입력하세요.",
    "onlineOnly": "공유를 관리하려면 인터넷에 연결하세요.",
    "you": "나",
    "ownerOnly": "접근 권한은 소유자만 변경할 수 있어요.",
    "unavailable": "지금은 공유를 사용할 수 없어요. 나중에 다시 시도하세요.",
    "updateFailed": "공유를 업데이트하지 못했어요. 다시 시도하세요.",
    "inviteInvalid": "이 초대는 더 이상 유효하지 않아요.",
    "copyLink": "링크 복사",
    "invited": "초대됨",
    "copied": "복사됨",
    "accessRestrictedHint": "초대한 사람만 열 수 있어요.",
    "onlyYouHint": "나만 열 수 있습니다.",
    "accessViewHint": "링크가 있는 누구나 계정 없이 읽을 수 있어요.",
    "accessEditHint": "링크가 있는 누구나 편집할 수 있어요.",
    "roleBelowLink": "링크가 있는 누구나 편집할 수 있으므로 초대한 사람도 편집할 수 있어요.",
    "inviteAs": "초대 권한",
    "revokeInvite": "초대 취소",
    "statusPeople_one": "{{count}}명",
    "statusPeople_other": "{{count}}명",
    "publicLink": "공개 링크",
    "statusFrom": "{{name}}님이 공유",
    "removeConfirmTitle": "{{name}} 님을 제거할까요?",
    "removeConfirmBody": "이 노트에 더 이상 접근할 수 없어요.",
    "revokeConfirmTitle": "{{name}} 님에게 보낸 초대를 취소할까요?",
    "revokeConfirmBody": "초대 링크가 더 이상 작동하지 않아요.",
    "peopleWithAccess": "액세스 권한이 있는 멤버",
    "addPeoplePlaceholder": "이메일로 멤버 추가",
    "invitePro": "멤버 초대는 Caliu Pro 기능입니다.",
    "inviteKeepsAccess": "링크를 꺼도 초대한 사람은 계속 접근할 수 있습니다.",
    "youSuffix": "(나)"
  },
  "noAccess": {
    "title": "이 노트에 접근할 수 없어요",
    "linkBody": "소유자가 이 노트를 공유하지 않았어요. 초대하거나 링크를 켜 달라고 요청하세요.",
    "signedOutBody": "공유받은 계정으로 로그인하세요.",
    "inviteTitle": "이 초대는 더 이상 유효하지 않아요",
    "inviteBody": "초대한 사람에게 새 초대를 요청하세요.",
    "removedTitle": "이 노트에 더 이상 접근할 수 없어요",
    "removedBody": "소유자가 회원님을 제거했어요.",
    "removedCopyBody": "소유자가 회원님을 제거했어요. 보내지 않은 변경 사항은 노트에 사본으로 보관했어요.",
    "backToNotes": "노트로 돌아가기",
    "signIn": "로그인"
  }
}
